/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /*
   * Вид для таймера обратного отсчета до окончания СП
   */
  app.JointPurchaseTimerView = app.View.extend({
    events: {
      'click .js-request-button': 'proceedToJpRequest'
    },
    el: '.js-timer-container',

    run: function (options) {
      this.model = this.model || new app.Model();
      if (options && options.organizerId) {
        this.model.set('organizerId', options.organizerId);
      }
      this.template = app.helpers.TemplateHelper.getTemplate('#jp-timer-template');

      this.render();
      this.timerId = setInterval(this.render.bind(this), 60 * 1000);
    },

    render: function () {
      var endDate = moment(this.model.get('ended_at')),
        now = moment(),
        timeLeft = moment.duration(endDate.diff(now)),
        endDateString = endDate.format('DD.MM.YYYY'),

        // Получаем длину интервала в днях
        durationInDays = Math.floor(timeLeft.asDays()),

        // Добавляем ведущий ноль, если однозначное число
        days = _.padStart(durationInDays, 2, '0'),
        hours = _.padStart(timeLeft.hours(), 2, '0'),
        minutes = _.padStart(timeLeft.minutes(), 2, '0'),

        // максимальные значения, которые позволяет отобразить таймер
        maxValues = {
          days: 99,
          hours: 23,
          minutes: 59,
        };

      // временная проверка чтобы не дезинформировать пользователей при количестве дней больше 99
      if (parseInt(days, 10) > maxValues.days) {
        days = String(maxValues.days);
        hours = String(maxValues.hours);
        minutes = String(maxValues.minutes);
      }

      this.$el.html(this.template({
        endDate: endDateString,
        id: this.model.get('id'),
        statusId: this.model.get('jp_status_id'),
        days1: days[0],
        days2: days[1],
        hours1: hours[0],
        hours2: hours[1],
        minutes1: minutes[0],
        minutes2: minutes[1],
        daysText: app.helpers.DeclinationHelper.format(+days, ['день', 'дня', 'дней']),
        hoursText: app.helpers.DeclinationHelper.format(+hours, ['час', 'часа', 'часов']),
        minutestText: app.helpers.DeclinationHelper.format(+minutes, ['минута', 'минуты', 'минут'])
      }));
    },

    /**
     * Сохранение айди органзиатора у пользователя и переход к оформлению заявки
     */
    proceedToJpRequest: function (e) {
      $(e.currentTarget).attr('disabled', true);
      app.user.saveJpOrganizer(
        this.model.get('organizerId'),
        {
          success: this.goToCheckout.bind(this)
        }
      );
    },

    /**
     * Переход на страницу оформления заказа
     */
    goToCheckout: function () {
      app.helpers.RedirectHelper.locationAssign('/checkout/');
    }
  });
})(jQuery);

}.call(window));